import { Box, styled } from "@mui/material";

export const NoDatasets = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));
